import { NotFound, Unauthorized } from '@register-ui/components';
import { PAGES } from '@register-ui/utils';
import { Navigate, type RouteObject } from 'react-router-dom';
import { RouteWrapper } from './route-wrapper';

import { appRoutes as managementRoutes } from '@register-ui/management';
import { appRoutes as onboardingRoutes } from '@register-ui/onboarding';
import { appRoutes as sellRoutes } from '@register-ui/sell';

export const notFoundRoute = { path: 'not-found', element: <NotFound /> };
export const unauthorized = { path: 'unauthorized', element: <Unauthorized /> };

export const dashboardAppRoutes: RouteObject = {
    path: 'register',
    async lazy() {
        const dashboard =
            await import('@/features/shared/layout/dashboard/dashboard');

        return { Component: dashboard.default };
    },
    children: [
        {
            path: 'base',
            async lazy() {
                const Home = await import('@/features/home');

                return { Component: Home.default };
            },
        },
        {
            path: '',
            element: <Navigate to={PAGES.HOME} replace />,
        },
        ...sellRoutes,
        ...managementRoutes,
        unauthorized,
        notFoundRoute,
    ],
};

const appRoutes: RouteObject[] = [
    {
        path: '/',
        element: <RouteWrapper />,

        children: [
            dashboardAppRoutes,
            ...onboardingRoutes,
            {
                path: '',
                element: <Navigate to={PAGES.HOME} replace />,
            },
            {
                path: 'sign-in',
                element: <Navigate to={PAGES.ONBOARDING.LANDING} replace />,
            },
            unauthorized,
            notFoundRoute,
            {
                path: 'health',
                element: <h1>All pages looking great!!</h1>,
            },
        ],
    },
];

// eslint-disable-next-line import/no-default-export
export default appRoutes;
